if (!customElements.get("rebuy-products")) {
  class RebuyProducts extends HTMLElement {
    static price_replace = ["{{amount}}", "{{amount_with_comma_separator}}"];
    constructor() {
      super();

      this._data = null;
      this.moneyFormat = this.getAttribute("js-money-format");
    }

    processPrice(price) {
      let priceHTML = this.moneyFormat;
      RebuyProducts.price_replace.forEach((format) =>
        priceHTML = priceHTML.replace(format, price)
      );

      if (!priceHTML.includes("span")) {
        priceHTML = `<span class="money">${priceHTML}</span>`;
      }

      return priceHTML;
    }

    productTemplate(product, variant) {
      const currentVariant = variant ?? product.variants[0];

      return `
      <div class="swiper-slide">
        <div class="rebuy-product" js-id="${product.id}">
          <a href="${product.link}" class="rebuy-product__image">
            <img src="${product?.image.src}" width="90" height="70" alt="${
        product.title
      }" loading="lazy" />
              </a>

              <div class="rebuy-product__info">
                  <a href="${product.link}" class="rebuy-product__title">${
        product.title
      }</a>

                <p class="rebuy-product__price">
                  ${this.processPrice(currentVariant.price)}

                  ${
                    currentVariant.compare_at_price &&
                    currentVariant.compare_at_price != currentVariant.price
                      ? this.processPrice(currentVariant.compare_at_price)
                      : ""
                  }
                </p>
              </div>

            <button type="button" class="button rebuy-product__button" data-id="${
              currentVariant.id
            }">
              <span class="button__text">Add</span>

              <span class="button__loader">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      `;
    }

    renderTemplate() {
      if (!this.data) return;

      const products = this.data
        .map((product) => this.productTemplate(product))
        .join("");

      this.innerHTML = `
        <div class="swiper-actions">
          <div class="swiper-button-prev">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_94_316" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
              <rect x="24" y="0.5" width="24" height="24" transform="rotate(90 24 0.5)" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_94_316)">
              <path d="M8.94625 12.5L14.6 6.84625L15.6537 7.9L11.0537 12.5L15.6537 17.1L14.6 18.1538L8.94625 12.5Z" fill="black"/>
              </g>
            </svg>
          </div>

          <div class="swiper-button-next">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_94_363" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
              <rect y="24.5" width="24" height="24" transform="rotate(-90 0 24.5)" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_94_363)">
              <path d="M15.0538 12.5L9.4 18.1537L8.34625 17.1L12.9463 12.5L8.34625 7.9L9.4 6.84625L15.0538 12.5Z" fill="black"/>
              </g>
            </svg>
          </div>
        </div>

        <div class="swiper">
          <div class="swiper-wrapper">
            ${products}
          </div>
        </div>
      `;

      requestAnimationFrame(() => {
        this.slider = new Swiper(this.querySelector(".swiper"), {
          spaceBetween: 15,
          slidesPerView: 1,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1440: {
              slidesPerView: 3,
            },
          },
        });

        const closestHidden = this.closest(".hidden");
        if (!closestHidden) return;

        closestHidden.classList.remove("hidden");
      });
    }

    get data() {
      return this._data;
    }

    set data(value) {
      this._data = value;

      this.renderTemplate();
    }

    init() {
      const requestParameters = new URLSearchParams({
        format: "pretty",
        shopify_product_ids: this.getAttribute("js-product-id"),
        key: "a210694a1fcc2faf82c6ed06da8ac3fd056e4ff8",
        bust_cache: "yes",
        context: {
          productId: `gid://shopify/Product/${this.getAttribute(
            "js-product-id"
          )}`,
        },
      });

      fetch(
        `https://rebuyengine.com/api/v1/custom/id/236641?${requestParameters}`
      )
        .then((response) => response.json())
        .then(data => {
          console.log(data);
          this.data = data.data;
        });
    }

    handleClick(event) {
      const button = event.target.closest("[data-id]");
      if (!button) return;

      const variantId = button.getAttribute("data-id");
      if (!variantId) return;

      const drawer = document
        .querySelector(".cart-drawer")
        ?.closest(".shopify-section");

      const sections = [];
      let item_count = 0;
      let sectionId;

      if (drawer) {
        sectionId = drawer.id.replace("shopify-section-", "");
      } else {
        sectionId = "cart-drawer";
      }

      sections.push(sectionId);

      let formData = {
        "items": [
          {
            "id": variantId,
            "quantity": 1,
          },
        ],
        "sections": sections.join(","),
      };

      button.setAttribute("aria-busy", "true");
      button.setAttribute("disabled", "disabled");

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then(async (data) => {
          const html = new DOMParser().parseFromString(
            data.sections[sectionId],
            "text/html"
          );
          const countBubble = html.querySelector(".count-bubble");
          if (countBubble) item_count = Number(countBubble.innerHTML);

          document.dispatchEvent(
            new CustomEvent("cart:change", {
              bubles: true,
              detail: {
                cart: {
                  sections: data.sections,
                  items: data.items,
                  item_count: item_count || data.items.length,
                },
              },
            })
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          button.removeAttribute("aria-busy");
          button.removeAttribute("disabled");

          const cartButton = document.querySelector(
            '[aria-controls="cart-drawer"]'
          );
          if (!cartButton) return;

          cartButton.click();
        });
    }

    connectedCallback() {
      this.init();
      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define("rebuy-products", RebuyProducts);
}
